// extracted by mini-css-extract-plugin
export default {"actionButton":"style_actionButton__gYK92","success":"style_success__7NIJ7","danger":"style_danger__z1sBB","primary":"style_primary__ZHfsX","content":"style_content__RZ0Sr"};